(() => {
  const componentSelector = 'finch-shoppable-videos[data-fsv-script]';
  const scriptPromises = new Map();

  const loadScript = (source) => {
    if (customElements.get('finch-shoppable-videos')) return Promise.resolve();
    if (scriptPromises.has(source)) return scriptPromises.get(source);

    const promise = new Promise((resolve, reject) => {
      const existingScript = Array.from(document.scripts).find(
        (script) => script.src === source
      );
      const script = existingScript || document.createElement('script');

      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });

      if (!existingScript) {
        script.src = source;
        script.defer = true;
        document.head.append(script);
      }
    });

    scriptPromises.set(source, promise);
    return promise;
  };

  const hydratePosters = (component) => {
    component.querySelectorAll('video[data-poster]').forEach((video) => {
      if (!video.dataset.poster) return;
      video.poster = video.dataset.poster;
      delete video.dataset.poster;
    });
  };

  const prepare = (component) => {
    if (component.dataset.fsvPrepared === 'true') return;
    component.dataset.fsvPrepared = 'true';

    let observer;
    let activationPromise;

    const cleanup = () => {
      observer?.disconnect();
      component.removeEventListener('pointerenter', activate);
      component.removeEventListener('pointerdown', activate);
      component.removeEventListener('focusin', activate);
      component.removeEventListener('touchstart', activate);
      component.removeEventListener('click', replayFirstClick, true);
    };

    const activate = () => {
      if (activationPromise) return activationPromise;
      cleanup();
      hydratePosters(component);
      activationPromise = loadScript(component.dataset.fsvScript).catch((error) => {
        delete component.dataset.fsvPrepared;
        if (window.Shopify?.designMode) {
          console.warn('Finch shoppable video kon niet worden geladen.', error);
        }
      });
      return activationPromise;
    };

    const replayFirstClick = (event) => {
      const button = event.target.closest?.('[data-fsv-play]');
      if (!button || customElements.get('finch-shoppable-videos')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      activate()?.then(() => button.click());
    };

    if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
      activate();
      return;
    }

    component.addEventListener('pointerenter', activate, { once: true });
    component.addEventListener('pointerdown', activate, { once: true });
    component.addEventListener('focusin', activate, { once: true });
    component.addEventListener('touchstart', activate, { once: true, passive: true });
    component.addEventListener('click', replayFirstClick, true);

    observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) activate();
      },
      { rootMargin: '300px 0px' }
    );
    observer.observe(component);
  };

  const scan = (root = document) => {
    root.querySelectorAll(componentSelector).forEach(prepare);
  };

  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
